// import React, { useState } from 'react'
// import {
//     ComposedChart,
//     XAxis,
//     YAxis,
//     Tooltip,
//     ResponsiveContainer,
//     Line,
//     LabelList,
// } from "recharts";
// import TempIcon from "../../../../../Assets/vitals/Temperature.svg";
// import LungIcon from "../../../../../Assets/vitals/Blood-Glucose.svg";
// import LiverIcon from "../../../../../Assets/vitals/Oxygen.svg";
// import HeartIcon from "../../../../../Assets/vitals/Heart-Rate.svg";
// import EcgIcon from "../../../../../Assets/vitals/respiration.svg";
// import WeightIcon from "../../../../../Assets/vitals/Weight.svg";
// import BloodPressureIcon from "../../../../../Assets/vitals/Blood-Pressure.svg";
// import { DatePicker } from 'antd';
// const data = [
//     { date: "01/8", systolic: 170, diastolic: 150 },
//     { date: "02/8", systolic: 120, diastolic: 80 },
// ];

// const metrics = [
//     {
//         key: "blood-pressure",
//         title: "Blood Pressure",
//         icon: BloodPressureIcon,
//         chartType: "bp",
//     },
//     {
//         key: "weight",
//         title: "BMI",
//         icon: WeightIcon,
//         chartType: "weight",
//     },
//     {
//         key: "ecg",
//         title: "Respiratory Rate",
//         icon: EcgIcon,
//         chartType: "ecg",
//     },
//     {
//         key: "heart",
//         title: "Heart Rate",
//         icon: HeartIcon,
//         chartType: "heart",
//     },
//     {
//         key: "liver",
//         title: "SpO2",
//         icon: LiverIcon,
//         chartType: "liver",
//     },
//     {
//         key: "lung",
//         title: "Blood Glucose",
//         icon: LungIcon,
//         chartType: "lung",
//     },
//     {
//         key: "temp",
//         title: "Temperature",
//         icon: TempIcon,
//         chartType: "temperature",
//     },
// ];

// function VitalTrends() {
//     const [selectedMetric, setSelectedMetric] = useState("blood-pressure");

//     const renderChart = () => {
//         if (selectedMetric === "blood-pressure") {
//             return (
//                 <>
//                     <div className="flex gap-4 mt-4 ml-4">
//                         <div className="flex items-center gap-1">
//                             <span className="w-3 h-1 rounded bg-[#5B8FF9]"></span>
//                             <p className="text-sm text-gray-600">systolic</p>
//                         </div>
//                         <div className="flex items-center gap-1">
//                             <span className="w-3 h-1 rounded bg-[#5AD8A6]"></span>
//                             <p className="text-sm text-gray-600">diastolic</p>
//                         </div>
//                     </div>

//                     <div className="mt-6 w-full h-72">
//                         <ResponsiveContainer width="100%" height="100%">
//                             <ComposedChart data={data}>
//                                 <XAxis dataKey="date" />
//                                 <YAxis domain={[0, 200]} />
//                                 <Tooltip />
//                                 <Line
//                                     type="monotone"
//                                     dataKey="systolic"
//                                     stroke="#5B8FF9"
//                                     dot={{ r: 6 }}
//                                 >
//                                     <LabelList dataKey="systolic" position="top" />
//                                 </Line>
//                                 <Line
//                                     type="monotone"
//                                     dataKey="diastolic"
//                                     stroke="#5AD8A6"
//                                     dot={{ r: 6 }}
//                                 >
//                                     <LabelList dataKey="diastolic" position="top" />
//                                 </Line>
//                             </ComposedChart>
//                         </ResponsiveContainer>
//                     </div>
//                 </>
//             );
//         }

//         return (
//             <div className="mt-6 w-full h-72 flex items-center justify-center text-gray-400">
//                 <p className="text-sm">No chart data available for {selectedMetric.replace("-", " ")}.</p>
//             </div>
//         );
//     };
//     return (
//         <div className="p-6">
//             <div className="flex justify-between flex-wrap gap-4">
//                 <h2 className="text-xl font-inter font-bold text-gray-800">Health Trends</h2>
//                 <div className="flex gap-8 text-center items-end flex-wrap">
//                     {metrics.map((metric) => (
//                         <div
//                             key={metric.key}
//                             className="flex flex-col items-center text-sm cursor-pointer"
//                             onClick={() => setSelectedMetric(metric.key)}
//                         >
//                             <img
//                                 src={metric.icon}
//                                 alt={metric.title}
//                                 className={`w-7 h-7 ${selectedMetric === metric.key ? "scale-110" : ""}`}
//                             />

//                         </div>
//                     ))}
//                 </div>
//                 <div>
//                     <DatePicker />
//                 </div>
//             </div>

//             <h3 className="mt-4 text-lg font-semibold text-center text-gray-700">
//                 {metrics.find((m) => m.key === selectedMetric)?.title}
//             </h3>

//             {/* Chart Content */}
//             {renderChart()}
//         </div>
//     )
// }

// export default VitalTrends;

// new code

import React, { useMemo, useState } from "react";
import {
  ComposedChart,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Line,
  LabelList,
} from "recharts";
import { DatePicker } from "antd";
import TempIcon from "../../../../../Assets/vitals/Temperature.svg";
import LiverIcon from "../../../../../Assets/vitals/Oxygen.svg";
import HeartIcon from "../../../../../Assets/vitals/Heart-Rate.svg";
import EcgIcon from "../../../../../Assets/vitals/respiration.svg";
import WeightIcon from "../../../../../Assets/vitals/Weight.svg";
import BloodPressureIcon from "../../../../../Assets/vitals/Blood-Pressure.svg";
import { convertUTCDateLocal } from "../../../../../utils/convertionFunc";
import bloodGlucoseIcon from "../../../../../Assets/vitals/Blood-Glucose.svg";

const VITAL_COLUMN_DETAILS = {
  BP: {
    label: "Blood Pressure",
    keys: ["BPS", "BPD"],
    icon: BloodPressureIcon,
  },
  RR: { label: "Respiratory Rate", keys: ["RR"], icon: EcgIcon },
  TP: { label: "Temperature", keys: ["TP"], icon: TempIcon },
  HR: { label: "Heart Rate", keys: ["HR"], icon: HeartIcon },
  SPO2: { label: "SpO2", keys: ["SPO2"], icon: LiverIcon },
  WE: { label: "Weight", keys: ["WE"], icon: WeightIcon },
  BMI: { label: "BMI", keys: ["BMI"], icon: WeightIcon },
  BG: { label: "Blood Glucose", keys: ["BG"], icon: bloodGlucoseIcon },
};

function VitalTrends({ data, rpmConfigVitalsList, vitalDisplayMap }) {
  const configuredVitals = useMemo(() => {
    // let codes = Object.entries(rpmConfigVitalsList || {})
    //     .filter(([_, value]) => value === 1)
    //     .map(([code]) => vitalDisplayMap[code])
    //     .filter((code) => code && VITAL_COLUMN_DETAILS[code]);

    let configured = Object.entries(rpmConfigVitalsList || {}).filter(
      ([key, value]) => key !== "status" && value === 1
    );
    let mapped = configured.map(([code]) => vitalDisplayMap[code]);
    let codes = mapped.filter((code) => {
      if (code) {
        if (code === "BPS" || code === "BPD") {
          return code;
        }
      }
      return VITAL_COLUMN_DETAILS[code];
    });
    const hasBPS = codes.includes("BPS");
    const hasBPD = codes.includes("BPD");

    if (hasBPS && hasBPD) {
      codes = codes.filter((c) => c !== "BPS" && c !== "BPD");
      codes.unshift("BP");
    }

    return [...new Set(codes)];
  }, [rpmConfigVitalsList, vitalDisplayMap]);


  const [selectedVital, setSelectedVital] = useState(
    configuredVitals[0] || null
  );

  const chartData = useMemo(() => {
    return data.map((item) => {
      const point = {
        date: convertUTCDateLocal(item.recordedDateTime, "DD/MM"),
      };
      configuredVitals.forEach((code) => {
        const keys = VITAL_COLUMN_DETAILS[code]?.keys || [];
        keys.forEach((key) => {
          point[key] = item[key] ?? null;
        });
      });
      return point;
    });
  }, [data, configuredVitals]);

  const renderChart = () => {
    if (!selectedVital) return null;

    const details = VITAL_COLUMN_DETAILS[selectedVital];
    if (!details || !details.keys.length) return null;

    return (
      <>
        {selectedVital === "BP" && (
          <div className="flex gap-4 mt-4 ml-4">
            <div className="flex items-center gap-1">
              <span className="w-3 h-1 rounded bg-[#5B8FF9]"></span>
              <p className="text-sm text-gray-600">Systolic</p>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-3 h-1 rounded bg-[#5AD8A6]"></span>
              <p className="text-sm text-gray-600">Diastolic</p>
            </div>
          </div>
        )}

        <div className="mt-6 w-full h-72">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={chartData}>
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              {details.keys.map((key, index) => (
                <Line
                  key={key}
                  type="monotone"
                  dataKey={key}
                  stroke={index === 0 ? "#5B8FF9" : "#5AD8A6"}
                  dot={{ r: 6 }}
                >
                  <LabelList dataKey={key} position="top" />
                </Line>
              ))}
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </>
    );
  };

  if (configuredVitals.length === 0) {
    return <p>No vitals configured for this patient.</p>;
  }

  return (
    <div className="p-6">
      <div className="flex justify-between flex-wrap gap-4 items-end">
        <h2 className="text-xl font-inter font-bold text-gray-800">
          Health Trends
        </h2>

        <div className="flex gap-8 text-center items-end flex-wrap justify-center flex-1">
          {configuredVitals.map((code) => {
            const icon = VITAL_COLUMN_DETAILS[code]?.icon;
            return (
              <div
                key={code}
                className="flex flex-col items-center text-sm cursor-pointer"
                onClick={() => setSelectedVital(code)}
              >
                <img
                  src={icon}
                  alt={code}
                  className={`w-7 h-7 ${
                    selectedVital === code ? "scale-110" : ""
                  }`}
                />
              </div>
            );
          })}
        </div>

        <div>
          <DatePicker style={{ visibility: "hidden" }} />
        </div>
      </div>

      <h3 className="mt-4 text-lg font-semibold text-center text-gray-700">
        {VITAL_COLUMN_DETAILS[selectedVital]?.label}
      </h3>

      {renderChart()}
    </div>
  );
}

export default VitalTrends;
